export const GET_ROOMS_LIST = 'get-rooms-list';
export const GET_ROOT_HOUSE_KEEPING_LIST = 'get_root_house_keeping_list';
export const GET_ROOM_TYPES = 'get-room-types';
export const GET_COMPLEMENTARIES_LIST = 'get-complementaries-list';
export const GET_BOARD_SERVICES_LIST = 'get-board-services-list';
export const GET_ADDONS_LIST = 'get-addons-list';
export const GET_FREQUENCIES_LIST = 'get-FREQUENCIES-list';
export const GET_PACKAGES_LIST = 'get-packages-list';
export const GET_CURRENCIES_LIST = 'get-currencies-list';
export const GET_RATE_TYPES_LIST = 'get-rate-types-list';
export const GET_CHARGE_CODES_LIST = 'get-charge-codes-list';
export const GET_MARKET_CODES_LIST = 'get-market-codes-list';
export const GET_SEGMENT_MARKET_CODES_LIST = 'get-segment-market-codes-list';
export const GET_SEASONS_LIST = 'get-seasons-list';
export const GET_AGE_RANGES_LIST = 'get-age-ranges-list';
export const GET_PAYMENT_METHODS_LIST = 'get-payment-methods-list';
export const GET_CANCELLATION_PENALITY_LIST = 'get-cancellation-penality-list';
export const GET_NOS_SHOWPENALITY_LIST = 'get-nos-ShowPenality-list';
export const GET_DEPOSIT_REQUEST_LIST = 'get-deposit-request-list';
export const GET_PROMOS_LIST = 'get-promos-list';
export const GET_AEROPORTS_LIST = 'get-aerports-list';
export const GET_SOURCES_LIST = 'get-sources-list';
export const GET_ORIGIN_OF_BOOKING_LIST = 'get-origin-of-booking-list';
export const GET_DEPARTMENTS_STAFFS_DEPARTMENTS_LIST = 'get-departments-staffs-departments-list';
export const GET_DEPARTMENTS_STAFFS_STAFFS_LIST = 'get-departments-staffs-staffs-list';
export const GET_RESERVATION_STATE_LIST = 'get-reservation-state-list';
export const GET_RESERVATION_BLOCS = 'get-house-keeping-blocs-list';
export const GET_HOUSEKEEPING_STATES = 'get-house-keeping-states-list';
export const GET_HOUSEKEEPING_MAINTAINCE_TYPES = 'get-house-keeping-maintaince-type-list';
export const GET_HOUSEKEEPERS = 'get-house-keepinger-list';
export const GET_RESERVATION_FEATURES_LIKES_LIST = 'get-reservation-features-likes-list';
export const GET_CARDS_LIST = 'get-cards-list';
export const GET_RATES_LIST = 'get-rates-list';
export const GET_NATIONALITIES_LIST = 'get-nationalities-list';
export const GET_RATES_BY_MARKET_AND_CARD = 'get-rates-by-market-and-card';
export const GET_RESERVATIONS_DEPENDENCIES_LIST = 'get-reservation-dependencies-list';
export const GET_ROOMS_TYPES_LIST = 'get-rooms-types-list';
export const GET_ROOMS_FLOORS_LIST = 'get-rooms-floors-list';
export const GET_ROOMS_CATEGORIES_LIST = 'get-rooms-categories-list';
export const GET_ROOMS_LIST_LIST = 'get-rooms-lists-list';
export const GET_SECTIONS_LIST = 'get-serctions-list';
export const GET_GUEST_PAYMENT_METHODS_LIST = 'get-serctions-list';
export const GET_DISCOUNT_TYPE_LIST = 'get-discount-type-list';
export const GET_ROOMING_LIST = 'get-rooming-list';
export const RESERVATION_GROUP_DETAILS = 'reservation-group-details';
